<template lang="pug">
	div
		h2.content-block {{ $tCaption('Home') }}
		.content-block
			.dx-card.responsive-paddings
				.logos-container
					img(src="../assets/logo_transparent.png" width="300px")
				p
					span {{ $tCaption('Welcome to') }}
					b  Adthos©
					span !
					.flex-row.align-center.space
						span {{ $tCaption('Need help? Check our') }}
						a(href="https://wedelsoft.atlassian.net/wiki/spaces/AP", target="_blank") {{ $tCaption('documentation!') }}
				ProductSelectionComponent(:items="fastLinks")
</template>

<script>
	import ProductSelectionComponent from 'view/proposal/ProductSelectionComponent.vue';

	export default {
		translationCategory: 'home',
		name: 'home',
		components: {
			ProductSelectionComponent
		},
		data: function () {
			return {
			};
		},
		computed: {
			fastLinks() {
				const result = [
					{
						icon: 'fas fa-business-time',
						name: this.$tCaption('New campaign'),
						click: () => {
							if (this.$auth.hasCreativeApi())
								return this.$router.push({ path: '/campaign/Detail/new' });
							if (this.$auth.hasAccessToQuote())
								return this.$router.push({ path: '/proposal/Builder' });
						},
						hidden: () => !(this.$auth.hasCreativeApi() || this.$auth.hasAccessToQuote()),
					},
					{
						icon: 'fas fa-file-audio',
						name: this.$tCaption('New creative'),
						click: () => this.$Data.createUpdateCreative({
							Oid: null,
							Name: 'New creative',
						}).then(r => {
							this.$router.push({path: `/creative/Detail/${r.Data.Oid}`, params: {isNew: true}});
						}),
					},
				];
				return result.filter(f => !f.hidden || !f.hidden());
			}
		}
	};
</script>

<style lang="scss">
	.logos-container {
		margin: 20px 0 40px 0;
		text-align: center;

		svg {
			display: inline-block;
		}
	}

	.devextreme-logo {
		width: 200px;
		height: 34px;
		margin-bottom: 17px;
	}

	.vue-logo {
		width: 180px;
		height: 62px;
	}

	.plus {
		margin: 20px 10px;
		width: 22px;
		height: 22px;
	}

	.screen-x-small .logos-container {
		svg {
			width: 100%;
			display: block;

			&.plus {
				margin: 0;
			}
		}
	}
</style>
